import Vue from 'vue';
import { API_HOST } from '../constants';

/* eslint-disable camelcase */

export default {
  get(params) {
    return Vue.axios.get(`${API_HOST}/order`, { params });
  },
  getById(id) {
    return Vue.axios.get(`${API_HOST}/order/${id}`);
  },
  post(params) {
    return Vue.axios.post(`${API_HOST}/order`, params);
  },
  compute(ids) {
    return Vue.axios.get(`${API_HOST}/compute-order`, { params: { ids } });
  },
  collectionCost(parcel_id) {
    return Vue.axios.get(`${API_HOST}/collection-cost`, { params: { parcel_id } });
  },
  checkUnpaidOrder() {
    return Vue.axios.get(`${API_HOST}/check-unpaid-order`);
  },
};



// WEBPACK FOOTER //
// ./src/api/order.js